import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AsyncValidatorFn, ValidatorFn, Validators } from '@angular/forms';
import { DynamicFormComponent } from '../../../../shared/dynamic-form/dynamic-form.component';
import { FieldOptions } from '../../../../shared/dynamic-form/interfaces/field-options.interface';
import { DisplayLabel } from '../../../../shared/models/displayLabel';
import { SupportTypes } from '../../../../shared/models/enums/support-type.enum';
import { StructureDto } from '../../../../shared/models/structure.dto';
import { StructureSupportPlaces } from '../../../../shared/models/structureSupportPlaces';
import { AreaService } from '../../../../shared/services/area.service';
import { SupportTypeService } from '../../../../shared/services/supportType.service';
import { Utils } from '../../../../shared/utils';
import { StructureValidators } from '../../../../shared/validators/structure.validators';

@Component({
  selector: 'app-structure-support-places',
  templateUrl: './structure-support-places.component.html',
  standalone: false,
})
export class StructureSupportPlacesComponent implements OnInit {
  public validators: ValidatorFn[] = [];
  public asyncValidators: AsyncValidatorFn[] = [];
  public supportTypePlaceFields: (string | FieldOptions)[] = [];
  public clis: DisplayLabel[] = [];
  public supportTypes: DisplayLabel[];

  @Input() public structure: StructureDto;

  public submitted: boolean = false;

  constructor(
    private readonly supportTypeService: SupportTypeService,
    private readonly areaService: AreaService,
  ) {}

  @ViewChild('supportTypePlaces', { static: false }) public places: DynamicFormComponent;

  public async ngOnInit(): Promise<void> {
    this.supportTypes = (await this.supportTypeService.findAll()).filter((value) => value.id !== SupportTypes.HORS_ACCOMPAGNEMENT);
    this.clis = await this.areaService.findAllClis();
    this.supportTypePlaceFields = this.getSupportTypePlaceFields();
    this.validators = this.getValidators();

    this.structure.supportPlaces = this.sortSupportPlaces(this.structure.supportPlaces || []);
  }
  public onSubmit(): boolean {
    this.submitted = true;
    Object.assign(this.structure, { supportPlaces: this.places.items.value || [] });
    return this.places.form.valid;
  }

  private getValidators(): ValidatorFn[] {
    return [StructureValidators.uniqueSupportPlace];
  }

  private getSupportTypePlaceFields(): (string | FieldOptions)[] {
    return [
      { value: 'structureId', validators: [] },
      { value: 'cliId', validators: [Validators.required] },
      { value: 'supportTypeId', validators: [Validators.required] },
      {
        value: 'placesNumber',
        validators: [Validators.required, Validators.pattern(Utils.placesNumberPattern)],
      },
    ];
  }

  private sortSupportPlaces(supportPlaces: StructureSupportPlaces[]) {
    return supportPlaces.sort(
      (a, b) =>
        this.supportTypes.find((x) => x.id == a.supportTypeId).label.localeCompare(this.supportTypes.find((x) => x.id == b.supportTypeId).label) ||
        a.cliId - b.cliId,
    );
  }
}
